import React from 'react'
import ChanceAddForecastContainer from '../../containers/chancemng/ChanceAddForecastContainer'

const ChanceAddForecastPage = () => {
    return (
        <ChanceAddForecastContainer />
    )
}

export default ChanceAddForecastPage